export const asset_type_enum = {
  Episodes: 1268,
  Season: 1264,
  Series: 1259,
  Trailer: 1266,
  Movies: 1262,
  Live: 1265,
  NotFound: 404,
  // EPG program assets (asset_type = 'epg') come back with type 0
  Program: 0,
}

// A program whose start time has already passed is served as catch-up (the
// same rule PlayerView uses to pick CatchupPlayer over LiveChanelPlayer); one
// that has not started yet plays through the linear player.
export const isCatchUpAsset = ({
  type,
  startDate,
}: {
  type: number
  startDate: number
}) => type === asset_type_enum.Program && startDate * 1000 < Date.now()

// Program assets carry no mediaFiles, so their content length is the EPG slot
// they were scheduled into.
export const getProgramDuration = ({
  startDate,
  endDate,
}: {
  startDate: number
  endDate: number
}) => Math.max(0, endDate - startDate)

export type IComponents =
  | 'main'
  | 'fullposter'
  | 'personal_rail'
  | 'catchup'
  | '16x9_regular'
  | 'poster_regular'
  | 'poster_small'
  | 'mintely'
  | null

export interface IImage {
  objectType: 'KalturaMediaImage'
  id: string
  imageTypeId: number
  imageTypeName: '2x3' | '1x1' | '16x9' | 'TVGuide_1x1' | 'web_live_logo'
  isDefault: false
  ratio: '2x3' | '1x1' | '16x9'
  url: string
  version: 0
}

/*
*
    {
      objectType: 'KalturaMediaFile'
      additionalData: ''
      alternativeCdnAdapaterProfileId: 0
      altExternalId: ''
      altStreamingCode: ''
      assetId: 2015306
      catalogEndDate: 4070908800
      cdnAdapaterProfileId: 618
      duration: 2911
      dynamicData: {}
      externalId: '1_frcmb3xd_1_9rawpmah,1_frcmb3xd_1_q898jfdd,1_frcmb3xd_1_turszwmj,1_frcmb3xd_1_l24q3npq'
      externalStoreId: ''
      fileSize: 0
      id: 2996040
      isDefaultLanguage: false
      labels: ''
      language: ''
      opl: ''
      orderNum: 0
      startDate: 1680181505
      status: true
      type: 'Dash_playready'
      typeId: 2908
      url: 'https://reshet.g-mana.live/media/ed019b46-c4ef-45f9-a2f6-a3f1b17b3180/entryId/1_frcmb3xd/format/mpegdash/tags/mbr/f/a.mpd'
    },
    {
      objectType: 'KalturaMediaFile'
      additionalData: ''
      alternativeCdnAdapaterProfileId: 0
      altExternalId: ''
      altStreamingCode: ''
      assetId: 2015306
      catalogEndDate: 4070908800
      cdnAdapaterProfileId: 618
      duration: 2911
      dynamicData: {}
      externalId: '1_frcmb3xd_1_9rawpmah,1_frcmb3xd_1_q898jfdd,1_frcmb3xd_1_turszwmj,1_frcmb3xd_1_l24q3npq'
      externalStoreId: ''
      fileSize: 0
      id: 2996041
      isDefaultLanguage: false
      labels: ''
      language: ''
      opl: ''
      orderNum: 0
      startDate: 1680181505
      status: true
      type: 'Hls_fairplay'
      typeId: 2909
      url: 'https://reshet.g-mana.live/media/ed019b46-c4ef-45f9-a2f6-a3f1b17b3180/entryId/1_frcmb3xd/format/applehttp/tags/mbr/f/a.m3u8'
    },
    {
      objectType: 'KalturaMediaFile'
      additionalData: ''
      alternativeCdnAdapaterProfileId: 0
      altExternalId: ''
      altStreamingCode: ''
      assetId: 2015306
      catalogEndDate: 4070908800
      cdnAdapaterProfileId: 618
      duration: 2911
      dynamicData: {}
      externalId: '1_frcmb3xd_1_9rawpmah,1_frcmb3xd_1_q898jfdd,1_frcmb3xd_1_turszwmj,1_frcmb3xd_1_l24q3npq'
      externalStoreId: ''
      fileSize: 0
      id: 2996043
      isDefaultLanguage: false
      labels: ''
      language: ''
      opl: ''
      orderNum: 0
      startDate: 1680181505
      status: true
      type: 'dash_widevine'
      typeId: 2910
      url: 'https://reshet.g-mana.live/media/ed019b46-c4ef-45f9-a2f6-a3f1b17b3180/entryId/1_frcmb3xd/format/mpegdash/tags/mbr/f/a.mpd'
    },
    {
      objectType: 'KalturaMediaFile'
      additionalData: ''
      alternativeCdnAdapaterProfileId: 0
      altExternalId: ''
      altStreamingCode: ''
      assetId: 2015306
      catalogEndDate: 4070908800
      cdnAdapaterProfileId: 618
      duration: 2911
      dynamicData: {}
      externalId: '1_frcmb3xd_1_9rawpmah,1_frcmb3xd_1_q898jfdd,1_frcmb3xd_1_turszwmj,1_frcmb3xd_1_l24q3npq'
      externalStoreId: ''
      fileSize: 0
      id: 2996042
      isDefaultLanguage: false
      labels: ''
      language: ''
      opl: ''
      orderNum: 0
      startDate: 1680181505
      status: true
      type: 'Hss_playready'
      typeId: 2913
      url: 'https://reshet.g-mana.live/media/ed019b46-c4ef-45f9-a2f6-a3f1b17b3180/entryId/1_frcmb3xd/format/sl/tags/mbr/f/a.ism'
    }
* **/
export interface IKalturaMediaFile {
  objectType: 'KalturaMediaFile'
  additionalData: ''
  alternativeCdnAdapaterProfileId: 0
  altExternalId: ''
  altStreamingCode: ''
  assetId: number
  catalogEndDate: number
  cdnAdapaterProfileId: 619
  duration: 0
  dynamicData: {}
  externalId: string
  externalStoreId: ''
  fileSize: number
  id: number
  isDefaultLanguage: boolean
  labels: ''
  language: ''
  opl: ''
  orderNum: number
  startDate: number
  status: boolean
  type: 'dash_widevine' | 'HLS'
  typeId: 2910 | number
  url: string
}

export interface IFetchAssetData {
  executionTime: number
  result: {
    objectType: string
    error?: {}
    totalCount?: number
    objects?: [
      {
        objectType:
          | 'KalturaProgramAsset'
          | 'KalturaMediaAsset'
          | 'KalturaLiveAsset'
          | string
        createDate: number
        description: string
        endDate: number
        externalId: string
        id: number
        images: IImage[]
        mediaFiles: IKalturaMediaFile[]
        metas: {
          BackgroundColor: { objectType: 'KalturaStringValue'; value: string }
          ChannelId: { objectType: 'KalturaDoubleValue'; value: number }
          ChannelNumber?: { objectType: 'KalturaDoubleValue'; value: number }
          dualStreamEnabled: {
            objectType: 'KalturaBooleanValue'
            value: boolean
          }
          isLiveEvent: { objectType: 'KalturaBooleanValue'; value: boolean }
          CatalogStartDateTime: {
            objectType: 'KalturaLongValue'
            value: number
          }
          PlaybackEndDateTime: { objectType: 'KalturaLongValue'; value: number }
          E000?: { objectType: string; value: string }
          E001?: { objectType: string; value: string }
          E010?: { objectType: string; value: string }
          E011?: { objectType: string; value: string }
          E100?: { objectType: string; value: string }
          E101?: { objectType: string; value: string }
          E110?: { objectType: string; value: string }
          E111?: { objectType: string; value: string }
        }
        name: string
        relatedEntities: {}
        startDate: number
        tags: {
          ParentalRating: {
            objectType: 'KalturaMultilingualStringValueArray'
            objects: [
              { objectType: 'KalturaMultilingualStringValue'; value: string }
            ]
          }
        }
        type: 1265 | 1266 | 1268 | number
        updateDate: number
        entryId: ''
        externalIds: string
        geoBlockRuleId: 400 | number
        inheritancePolicy: 'Enable' | string
        status: boolean
        typeDescription: 'Linear'
        bufferCatchUpSetting: number
        bufferTrickPlaySetting: number
        enableCatchUp: boolean
        enableCdvr: boolean
        channelType: 'UNKNOWN'
        enableCatchUpState: 'INHERITED'
        enableCdvrState: 'INHERITED'
        enableRecordingPlaybackNonEntitledChannelState: 'INHERITED'
        enableStartOverState: 'INHERITED'
        enableTrickPlayState: 'INHERITED'
        externalCdvrId: ''
        externalEpgIngestId: 'reshet6'
        paddingAfterProgramEnds: 0
        paddingBeforeProgramStarts: 0
        enableRecordingPlaybackNonEntitledChannel: boolean
        enableStartOver: boolean
        catchUpBuffer: number
        trickPlayBuffer: number
        enableTrickPlay: boolean
      }
    ]
  }
}

export interface IOttSeason {
  id: number
  type: number
  name: string
  position: number
}

/**
 {
 objectType: 'KalturaMediaImage'
 id: 'a11ffe3a487541cd8e229b6ed31b31e5'
 imageTypeId: 148
 imageTypeName: '16x9'
 isDefault: false
 ratio: '16x9'
 url: 'https://images.frp1.ott.kaltura.com/Service.svc/GetImage/p/5031/entry_id/a11ffe3a487541cd8e229b6ed31b31e5/version/25'
 version: 25
 }*/
export interface IKalturaMediaImage {
  objectType: 'KalturaMediaImage'
  id: string
  imageTypeId: 148 | number
  imageTypeName: '16x9' | string
  isDefault: boolean
  ratio: '16x9' | string
  url: string
  version: number
}

export interface IOttEpisode {
  objectType: 'KalturaMediaAsset' | string
  createDate: number
  description: string
  endDate: number
  externalId: string
  id: number
  images: IKalturaMediaImage[]
  mediaFiles: IKalturaMediaFile[]
  metas: {
    RunTime: { objectType: 'KalturaStringValue'; value: string }
    SeasonNumber: { objectType: 'KalturaDoubleValue'; value: number }
    Adult: { objectType: 'KalturaBooleanValue'; value: false }
    ShortSummary: {
      objectType: 'KalturaMultilingualStringValue'
      value: string
    }
    SeriesID: { objectType: 'KalturaStringValue'; value: string }
    GeoBlockRule: {
      objectType: 'KalturaStringValue'
      value: 'Israel Only' | string
    }
    EpisodeNumber: { objectType: 'KalturaDoubleValue'; value: number }
    LongSummary: {
      objectType: 'KalturaMultilingualStringValue'
      value: string
    }
    MediaType: { objectType: 'KalturaStringValue'; value: 'Episode' | string }
    CatalogStartDateTime: { objectType: 'KalturaLongValue'; value: number }
    PlaybackEndDateTime: { objectType: 'KalturaLongValue'; value: number }
  }
  name: string
  relatedEntities: {}
  startDate: number
  tags: {
    ParentalRating: {
      objectType: 'KalturaMultilingualStringValueArray'
      objects: [
        { objectType: 'KalturaMultilingualStringValue'; value: 'P13' | string }
      ]
    }
    Genre: {
      objectType: 'KalturaMultilingualStringValueArray'
      objects: [
        { objectType: 'KalturaMultilingualStringValue'; value: 'בידור' },
        { objectType: 'KalturaMultilingualStringValue'; value: 'תוכניות אוכל' },
        { objectType: 'KalturaMultilingualStringValue'; value: 'ריאליטי' }
      ]
    }
    CountryOfOrigin: {
      objectType: 'KalturaMultilingualStringValueArray'
      objects: [
        { objectType: 'KalturaMultilingualStringValue'; value: 'Israel' }
      ]
    }
    Provider: {
      objectType: 'KalturaMultilingualStringValueArray'
      objects: [
        { objectType: 'KalturaMultilingualStringValue'; value: 'Reshet13' }
      ]
    }
    SeriesName: {
      objectType: 'KalturaMultilingualStringValueArray'
      objects: [{ objectType: 'KalturaMultilingualStringValue'; value: string }]
    }
    Quality: {
      objectType: 'KalturaMultilingualStringValueArray'
      objects: [{ objectType: 'KalturaMultilingualStringValue'; value: 'HD' }]
    }
    SeasonName: {
      objectType: 'KalturaMultilingualStringValueArray'
      objects: [{ objectType: 'KalturaMultilingualStringValue'; value: string }]
    }
  }
  type: 1268 | number
  updateDate: number
  entryId: string
  geoBlockRuleId?: number | 400
  inheritancePolicy: 'Enable'
  status: true
  typeDescription: 'Episode'
}
